import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Fade } from "react-awesome-reveal"; // Optional animation library

const Services = () => {
  return (
    <div className="w-full min-h-screen bg-gray-50 flex flex-col mt-24">
      <Navbar />

      {/* Hero Section */}
      <section className="w-full bg-gradient-to-r from-[#75000e] to-[#2c3e50] py-20 text-center text-white">
        <Fade direction="down" triggerOnce>
          <h1 className="text-4xl md:text-5xl font-bold drop-shadow-lg">
            About Globelink Techservices
          </h1>
          <p className="mt-4 max-w-2xl mx-auto text-lg md:text-xl font-sans leading-relaxed">
            Connecting talent with opportunity, one career at a time.
          </p>
        </Fade>
      </section>

      {/* Main Content Section with Margin */}
      <section className="flex-grow py-16 px-4 md:px-8 lg:px-16 mt-12 md:mt-16">
        <div className="container mx-auto max-w-5xl">
          <Fade direction="up" triggerOnce>
            <div className="bg-white rounded-lg shadow-xl p-8 md:p-12">
              {/* Commitment Section */}
              <h2 className="text-2xl md:text-3xl text-[#75000e] font-bold mb-6">
                Your Career, Our Commitment
              </h2>
              <p className="text-gray-600 font-sans leading-relaxed text-base md:text-lg">
                Globelink Techservices is a leading recruitment agency dedicated
                to helping companies find the best-fit candidates while
                assisting job seekers in securing their dream jobs. We focus on
                delivering tailored recruitment services that cater to the
                specific needs of both businesses and candidates, ensuring a
                perfect match every time.
              </p>

              {/* Specialization Section */}
              <h3 className="text-2xl md:text-3xl text-[#75000e] font-bold mt-12 mb-6">
                Our Specialization
              </h3>
              <p className="text-gray-600 font-sans leading-relaxed text-base md:text-lg">
                We specialize in providing exceptional recruitment solutions to
                businesses and career opportunities for job seekers. Whether
                you’re an organization looking for skilled professionals or a
                candidate aiming for your next career move, we connect the right
                talent with the right opportunity. Our goal is to ensure a
                seamless and hassle-free recruitment process.
              </p>

              {/* Industries Section */}
              <h3 className="text-2xl md:text-3xl text-[#75000e] font-bold mt-12 mb-6">
                Industries We Serve
              </h3>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 list-none pl-0">
                {[
                  "IT",
                  "Healthcare",
                  "Finance",
                  "Marketing",
                  "Engineering",
                ].map((industry, index) => (
                  <li
                    key={index}
                    className="flex items-center text-gray-600 font-sans text-base md:text-lg hover:text-[#75000e] transition-colors duration-300"
                  >
                    <svg
                      className="w-5 h-5 mr-2 text-[#75000e]"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    {industry}
                  </li>
                ))}
              </ul>
              <p className="text-gray-600 font-sans leading-relaxed text-base md:text-lg mt-6">
                Our team of experienced professionals works tirelessly to offer
                recruitment solutions that foster long-term success for both
                employers and employees.
              </p>

              
            </div>
          </Fade>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;
